import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=2bea8456&scoped=true&"
import script from "./ItemsTable.vue?vue&type=script&lang=js&"
export * from "./ItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=2bea8456&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea8456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDataTable,VFlex,VIcon,VLayout})
